<template>
  <div v-for="fam in AD_PRODUCT_FAMILIES" :key="fam.family" class="family-section">
    <div class="family-label">{{ fam.family }}</div>
    <div class="product-grid">
      <f7-link
        v-for="p in fam.products"
        :key="p.code"
        class="product-card"
        :class="{ selected: modelValue === p.code }"
        @click="$emit('update:modelValue', p.code)"
        role="button"
        tabindex="0"
        @keydown.enter="$emit('update:modelValue', p.code)"
        @keydown.space.prevent="$emit('update:modelValue', p.code)"
      >
        <f7-icon :f7="p.icon" :size="18" />
        <div class="product-name">{{ p.label }}</div>
        <div class="product-price">{{ priceLabel(p) }}</div>
      </f7-link>
    </div>
  </div>

  <div v-if="selectedMeta" class="product-desc-banner">
    <f7-icon f7="info_circle_fill" :size="14" />
    <span>{{ selectedMeta.desc }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { AD_PRODUCT_FAMILIES, productMeta, fmtCfa } from '../../constants/ad-products.js'

const props = defineProps({ modelValue: { type: String, default: null } })
defineEmits(['update:modelValue'])

const selectedMeta = computed(() => productMeta(props.modelValue))

function priceLabel(p) {
  const tiers = Object.values(p.rates)
  const low = Math.min(...tiers)
  const high = Math.max(...tiers)
  const range = low === high ? fmtCfa(low) : `${fmtCfa(low)}–${fmtCfa(high)}`
  return `${range} ${p.unit}`
}
</script>

<style scoped>
.family-section { margin-bottom: 14px; }
.family-label {
  font-size: 11px; font-weight: 500; text-transform: uppercase;
  letter-spacing: .04em; color: var(--f7-on-surface-variant, #8e8e93);
  margin-bottom: 6px;
}
.product-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.product-card {
  border: 1px solid var(--f7-list-item-border-color, var(--f7-list-item-border-color, #e0e0e0));
  border-radius: 10px; padding: 10px;
  text-decoration: none;
  color: inherit;
}
.product-card.selected {
  border: 1.5px solid var(--f7-theme-color);
  background: color-mix(in srgb, var(--f7-theme-color) 8%, transparent);
}
.product-name { font-size: 12px; font-weight: 500; margin: 5px 0 2px; }
.product-price { font-size: 10px; color: var(--f7-theme-color); }
.product-desc-banner {
  display: flex; gap: 7px; align-items: flex-start;
  background: var(--f7-list-bg-color, #f5f5f5); border-radius: 8px;
  padding: 9px 11px; font-size: 12px; line-height: 1.5; margin-top: 4px;
}
</style>
